import ToolMark from '../../tools/ToolMark';
// Toggles an underline mark on the currently selected elements.

class ToolStrikethrough extends ToolMark {
  static toolName = 'Strikethrough';
  static iconClass = 'fa-regular fa-strikethrough';
  static mark = 'strikethrough' as const;
  static shortcut = 'Cmd+Shift+x';
}

export default ToolStrikethrough;
